const KpiTypes = {
    DISTANCE: '1',
    HSR: '2',
    SPRINT: '3',
    TURNS: '4'
}

export { KpiTypes }